import { render, staticRenderFns } from "./FormQuoteTemplate.vue?vue&type=template&id=21994df4&"
import script from "./FormQuoteTemplate.vue?vue&type=script&lang=js&"
export * from "./FormQuoteTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormQuoteTemplate.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports